module.exports = __webpack_public_path__ + "images/hero-campaign-banner-bg.jpg";